const mutations = {
    COMMIT_ELECTRICITY_CATEGORIES: (state, payload) => {
        state.electricity_categories = payload
    },

    COMMIT_CABLE_CATEGORIES: (state, payload) => {
        state.cable_categories = payload
    },

    COMMIT_CABLE_PRODUCTS: (state, payload) => {
        state.cable_products = payload
    },

    COMMIT_EDUCATION_CATEGORIES: (state, payload) => {
        state.education_categories = payload
    },
}

export default mutations
